import { render, staticRenderFns } from "./BillDetails.vue?vue&type=template&id=4ad85773&scoped=true"
import script from "./BillDetails.vue?vue&type=script&lang=js"
export * from "./BillDetails.vue?vue&type=script&lang=js"
import style0 from "./BillDetails.vue?vue&type=style&index=0&id=4ad85773&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad85773",
  null
  
)

export default component.exports